// src/services/journalService.js
import { JournalAPI } from './journalApi';

export const journalService = {
  async getEntriesPaginated(page, pageSize, customerId, sortOrder = 'desc') {
    const response = await JournalAPI.getEntriesPaginated(page, pageSize, customerId, sortOrder);
    return response; // Returns { success, data, hasMore, total, page, pageSize }
  },

  async createEntry(entryData) {
    const response = await JournalAPI.createEntry(entryData);
    return response; // Returns { success, data }
  },

  async updateEntry(entryId, entryData) {
    const response = await JournalAPI.updateEntry(entryId, entryData);
    return response; // Returns { success, data }
  },

  async deleteEntry(entryId) {
    const response = await JournalAPI.deleteEntry(entryId);
    return response; // Returns { success }
  }
};